export default __webpack_public_path__ + "static/media/xmark-solid.76b0dd8a.svg";